import 'swiper/scss';

import { Swiper, SwiperSlide } from 'swiper/react';

import { useGetMainNumbersData, useGetPrettyNumbersData } from '@/api';
import { ChosenNumber } from '@/types';

import { TariffBlock } from '../TariffBlock/TariffBlock.tsx';
import cn from './styles.module.scss';

interface ITariffCarouselProps {
    onClick?: (chosenNumber: ChosenNumber) => void;
    tariffs: string[];
    number: string;
    operator: string;
    region: string;
    minTariffPrice: number;
    numberCost: number;
}

export const TariffCarousel = ({
    onClick,
    tariffs,
    number,
    operator,
    region,
    minTariffPrice,
    numberCost,
}: ITariffCarouselProps) => {
    const { data: mainTariffsData } = useGetMainNumbersData();
    const { data: prettyNumsTariffsData } = useGetPrettyNumbersData();

    const tariffsData = mainTariffsData || prettyNumsTariffsData;

    const tariffList = tariffs
        .map(tariffId => tariffsData?.tariffs.find(({ sid }) => sid === tariffId))
        .filter(tariff => tariff !== undefined);

    return (
        <Swiper className={cn.tariffCarousel} slidesPerView="auto" spaceBetween={8}>
            {tariffList?.map(tariff => {
                const data = mainTariffsData || prettyNumsTariffsData;
                const deviceTypeObj = data?.deviceTypes.find(item => item.id === tariff.deviceType);

                return (
                    <SwiperSlide key={tariff.sid} className={cn.allNumsSlide}>
                        <TariffBlock
                            numberCost={numberCost}
                            region={region}
                            operator={operator}
                            number={number}
                            onClick={onClick}
                            activationFee={tariff.activationFee}
                            tariffMin={tariff.minutesAmount}
                            tariffInternet={tariff.trafficAmount}
                            tariffName={tariff.name.replaceAll('&infin;', '∞')}
                            tariffPrice={tariff.publicPrice + numberCost}
                            tariffSms={tariff.smsAmount}
                            tariffSid={tariff.sid}
                            tariffs={tariffs}
                            minTariffPrice={minTariffPrice}
                            properties={tariff.options}
                            deviceType={deviceTypeObj?.name || ''}
                        />
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
};
